module.exports = __webpack_public_path__ + "img/logoWithText.6aa1232d.svg";